import * as yup from "yup";

export const shiftLogEventDataValidation = yup.object().shape({
	date: yup.date().required("Date is required"),
	description: yup.string().required("Description is required"),

	systems: yup.array().of(yup.number()).min(1, "System is required").required(),
	groups: yup.array().of(yup.number()).min(1, "Group is required").required(),

	tags: yup.array().of(yup.string()),
	isHandoverEvent: yup.boolean(),
	isOutOfService: yup.boolean(),
});
